import { RootPaths } from "@src/appV2/App/paths";
import { Callout } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { minutesToMilliseconds } from "date-fns";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { useIsInHomeEnabled } from "../../InHome/lib/useIsInHomeEnabled";
import { useWorkerPendingVisitInvites } from "../../InHome/VisitInvites/api/useWorkerPendingVisitInvites";
import { useWorkerPendingShiftInvites } from "../../WorkerShifts/ShiftInvites/api/useWorkerPendingShiftInvites";
import { logInviteCalloutViewed } from "./logInviteCalloutViewed";

export function ShiftInvitesCallout() {
  const history = useHistory();
  const { stage } = useDefinedWorker();
  const isInHomeEnabled = useIsInHomeEnabled();

  const queryOptions = {
    // The shift discovery page remains mounted when opening shifts in bottom sheets,
    // preventing automatic refetches of the query on mount. Setting a stale time ensures invites
    // are periodically refreshed even without unmounting.
    staleTime: minutesToMilliseconds(2),
  };

  const { data: shiftInvitesData, isSuccess: isShiftInvitesSuccess } = useWorkerPendingShiftInvites(
    {
      options: queryOptions,
    }
  );

  const { data: visitInvitesData, isSuccess: isVisitInvitesSuccess } = useWorkerPendingVisitInvites(
    {
      options: {
        ...queryOptions,
        enabled: isInHomeEnabled,
      },
    }
  );

  const shiftInviteCount = isShiftInvitesSuccess ? shiftInvitesData.data.length : 0;
  const visitInviteCount =
    isInHomeEnabled && isVisitInvitesSuccess ? visitInvitesData.data.length : 0;
  const totalInviteCount = shiftInviteCount + visitInviteCount;

  if (totalInviteCount <= 0) {
    return null;
  }

  return (
    <Callout
      title={`${totalInviteCount} ${pluralize("Invite", totalInviteCount)}`}
      iconType="invite"
      sx={(theme) => ({
        backgroundColor: theme.palette.shift?.priority.background,
        color: theme.palette.shift?.priority.text,
      })}
      onClick={() => {
        logInviteCalloutViewed({
          source: "shiftDiscovery",
          workerStage: stage,
          shiftInviteCount,
          visitInviteCount,
        });
        history.push(`${RootPaths.APP_V2_HOME}/myShifts/shiftInvites`);
      }}
    />
  );
}
